import {
  Avatar,
  Col,
  Icon,
  Layout,
  Drawer,
  Menu,
  Row,
  Popover,
  Divider,
  Radio,
  Button,
  Modal,
} from "antd";
import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import withSharedStateConsumer from "../../../contexts/shared-state/withSharedStateConsumer";
import vodafone from "../../../resource/vodafoneIVR.png";
import { routes } from "../Routes";
import "./AdaptiveDrawer.css";
import { CfgUserService } from "../../../services/cfgUser/CfgUserService";
import { UserService } from "../../../services/user/UserService";
import { FileService } from "../../../services/file/FileService";
import { handleError } from "../../../utils/ErrorHandlers";
import { showSuccessToast } from "../../general/ToastHelper";
import userAvatar from "../../../resource/user.jpg";
import LanguageSwitcher from "../../LanguageSwitcher";
import HintModal from "../HintModal";
import { Translation } from "react-i18next";
import i18next from "i18next";
const { Header, Sider } = Layout;

const SubMenu = Menu.SubMenu;

class AdaptiveDrawer extends React.Component {
  userService = new UserService();
  fileService = new FileService();
  cfgUserService = new CfgUserService();
  state = {
    collapsed: true,
    showSider: window.innerWidth < 690 ? false : true,
    placement: "left",
    value: "",
    loading: false,
    popOverVisibility: false,
    allAgentStatus: [],
    visibleModel: false,
    onlineAvailability: 0,
    oldStatus: this.props.context.user.userStatus,
  };

  updateDimensions = () => {
    if (window.innerWidth < 690) {
      this.setState({ showSider: false });
    } else {
      this.setState({ showSider: true });
    }
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    let { updateUserImg } = this.props.context;
    let response = await this.getUserImg(
      this.props.context.session_id,
      this.props.context.user.userId
    );
    updateUserImg(response + "");

    this.setState({
      value: this.props.context.user.userStatus,
    });
    if (this.props.context.user.userType == "AGENT") {
      try {
        this.setState({ loading: true });
        let allAgentStatus = await this.userService.getAllAgentStatusService(
          this.props.context.session_id
        );

        this.setState({
          allAgentStatus: allAgentStatus.ivrList,
          loading: false,
        });
      } catch (e) {
        this.setState({ loading: false });
        handleError(e);
      }
    }
  }
  async getUserImg(session_id, user_id) {
    try {
      return await this.fileService.getUserImg(session_id, user_id);
    } catch (e) {
      return userAvatar;
    }
  }
  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  onChange = async (e) => {
    let { updateUser } = this.props.context;

    this.setState({
      value: e.target.value,
    });

    let cfg = {
      key: "AGENT_STATUS",
      value: e.target.value,
      configCategory: "CTI",
      userId: this.props.context.user.userId,
    };
    let agentChangeStatus = {
      agentId: this.props.context.user.userId,
      accountId: this.props.context.user.accountId,
      fromState: this.props.context.user.userStatus,
      toState: e.target.value,
      changedBy: this.props.context.user.userId,
    };
    let { user } = this.props.context;
    user.userStatus = e.target.value;
    try {
      this.cfgUser = new CfgUserService();
      this.setState({ loading: true });

      let data = await this.cfgUser.editCfgUser(
        this.props.context.session_id,
        cfg
      );

      let response = await this.userService.changeAgentStatus(
        this.props.context.session_id,
        agentChangeStatus
      );
      this.setState({ oldStatus: e.target.value, loading: false });
      showSuccessToast(i18next.t("Status changed successfully"));
    } catch (e) {
      this.setState({
        value: this.state.oldStatus,
        loading: false,
      });
      handleError(e);
      return;
    }
    updateUser(user);
  };

  hidePopOver = () => {
    this.setState({
      popOverVisibility: false,
    });
  };

  handlePopOverVisibleChange = (visible) => {
    this.setState({ popOverVisibility: visible });
  };

  currentComponentActions(pathname) {
    if (
      pathname.includes("edit") ||
      pathname.includes("view") ||
      pathname.includes("addAccountNumber") ||
      pathname.includes("manageAccountNumber")
    ) {
      return pathname.split("/")[0] + "/" + pathname.split("/")[1];
    } else if (pathname.includes("admin/create")) {
      return (
        pathname.split("/")[0] +
        "/" +
        pathname.split("/")[1] +
        "/" +
        pathname.split("/")[2]
      );
    } else {
      return pathname;
    }
  }
  capitalize(st) {
    return st.charAt(0).toUpperCase() + st.slice(1);
  }

  render() {
    let { history } = this.props;
    let { hasAnyPrivilege } = this.props.context;
    let user_type = this.props.context.user.userType;

    const radioStyle = {
      display: "block",
      height: "30px",
      lineHeight: "30px",
    };
    const { allAgentStatus } = this.state;

    const agentStatusOptions = allAgentStatus.map((opt) => (
      <Radio
        style={radioStyle}
        value={opt.status}
      >
        {i18next.t(this.capitalize(opt.statusDescription))}
      </Radio>
    ));

    return (
      <Translation>
        {(t) => (
          <Layout>
            <Header className="header">
              <Col>
                <Col xs={{ span: 14 }} lg={{ span: 16 }}>
                  <Icon className="trigger" type="menu" onClick={this.toggle} />
                  <img
                    src={vodafone}
                    style={
                      this.props.context.curr_dir === "ltr" &&
                      this.props.context.curr_lang === "en"
                        ? {
                            width: "30px",
                            marginRight: "5px",
                            marginBottom: "5px",
                          }
                        : {
                            width: "30px",
                            marginLeft: "5px",
                            marginBottom: "5px",
                          }
                    }
                  />
                  <span className="header-title">{t("Vodafone Business IVR")}</span>
                </Col>
                <Col xs={{ span: 8 }} lg={{ span: 7 }} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  {/* <Link> */}
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Popover
                      visible={this.state.popOverVisibility}
                      onVisibleChange={(visible) =>
                        this.handlePopOverVisibleChange(visible)
                      }
                      placement="bottom"
                      trigger="click"
                      content={
                        <div>
                          <Link
                            style={{ color: "#585858" }}
                            to={"/home/profile"}
                            onClick={this.hidePopOver}
                          >
                            <Row style={{ padding: "10px" }}>
                              <Icon
                                style={
                                  this.props.context.curr_dir === "ltr" &&
                                  this.props.context.curr_lang === "en"
                                    ? { marginRight: "8px" }
                                    : { marginLeft: "8px" }
                                }
                                type="user"
                              />
                              <span>{t("Profile")}</span>
                            </Row>
                          </Link>
                          {this.props.context.user.userType === "AGENT" ? (
                            <div>
                              <Divider style={{ margin: "0px" }} />
                              <Radio.Group
                                style={{ padding: "10px" }}
                                onChange={this.onChange}
                                value={this.state.value}
                              >
                                {agentStatusOptions}
                              </Radio.Group>
                              <Divider style={{ margin: "0px" }} />
                            </div>
                          ) : null}
                          <Link
                            style={{ color: "#585858" }}
                            to={"/home/changePassword"}
                            onClick={this.hidePopOver}
                          >
                            <Row style={{ padding: "10px" }}>
                              <Icon
                                style={
                                  this.props.context.curr_dir === "ltr" &&
                                  this.props.context.curr_lang === "en"
                                    ? { marginRight: "8px" }
                                    : { marginLeft: "8px" }
                                }
                                type="sync"
                              />
                              <span>{t("Change Password")}</span>
                            </Row>
                          </Link>
                          <Divider style={{ margin: "0px" }} />
                          <Link
                            style={{ color: "#585858" }}
                            to={"/logout"}
                            onClick={this.hidePopOver}
                          >
                            <Row style={{ padding: "10px" }}>
                              <Icon
                                style={
                                  this.props.context.curr_dir === "ltr" &&
                                  this.props.context.curr_lang === "en"
                                    ? { marginRight: "8px" }
                                    : { marginLeft: "8px" }
                                }
                                type="logout"
                              />
                              <span>{t("Logout")}</span>
                            </Row>
                          </Link>
                        </div>
                      }
                    >
                      <img
                        className="user-img"
                        src={this.props.context.user_img}
                        style={{ cursor: "pointer" }}
                      />
                    </Popover>
                    <a
                      href="https://eur05.safelinks.protection.outlook.com/?url=https%3A%2F%2Fvhub.vodafone.com.eg%2F%2Fmedias%2F010-Hotline-Guide-V2.pdf%3Fcontext%3DbWFzdGVyfHJvb3R8MjQ3MDMxNnxhcHBsaWNhdGlvbi9wZGZ8aGUxL2hlNi85MjYyNDY3NDQ4ODYyLnBkZnxjZmUwOTdiZjk4YWQ4ZjU3MTFiOTFiMWNiNTI4OWI1OWIyZDRlNzM3YWFmNzVhMjEzMjMxYTIxNmNhNGZlN2U3&data=05%7C02%7Cnouran.mohamed3%40vodafone.com.eg%7C17672ba7d77b43a1cd6b08dd5caa8104%7C28d54ec722214717acb07f8c37359048%7C0%7C0%7C638768609580405867%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=95%2BgBJX7zXMXtPW5%2BBTE1jTpqow7%2Bb9nDxfyGnLJx1E%3D&reserved=0"
                      target="_blank"
                      rel="help"
                      style={{ 
                        marginLeft: '15px',
                        color: '#e60000',
                        fontWeight: 'bold',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center'
                      }}
                    >
                      {t("Help?")}
                    </a>
                  </div>
                  {/* </Link> */}
                </Col>
              </Col>
            </Header>
            <Layout>
              {this.state.showSider ? (
                <Sider
                  trigger={null}
                  collapsible
                  collapsed={this.state.collapsed}
                  width={220}
                >
                  {!this.state.collapsed && <div className="logo"></div>}

                  {routes && (
                    <Menu theme="light" mode="inline">
                      {routes.map((item, index) => {
                        let permissions = item.subRoutes.reduce(
                          (arr, next) => arr.concat(next.privileges),
                          []
                        );

                        if (
                          item.name == "Dashboard" &&
                          user_type != "SUPER" &&
                          user_type != "CARE" &&
                          user_type != "LI" &&
                          (item.access || hasAnyPrivilege(permissions))
                        ) {
                          return (
                            <Menu.Item
                              key={item.subRoutes[0].key}
                              icon={item.icon}
                            >
                              <Link to={`/home/${item.subRoutes[0].key}`}>
                                <span>
                                  <Icon type={item.icon} />
                                  <span>{t(item.subRoutes[0].name)}</span>
                                </span>
                              </Link>
                            </Menu.Item>
                          );
                        } else if (
                          item.name != "Dashboard" &&
                          (item.access || hasAnyPrivilege(permissions))
                        ) {
                          return (
                            <SubMenu
                              key={index}
                              title={
                                <span>
                                  <Icon type={item.icon} />
                                  <span>{t(item.name)}</span>
                                </span>
                              }
                            >
                              {item.subRoutes.map(function (route) {
                                if (
                                  route.access ||
                                  hasAnyPrivilege(route.privileges)
                                ) {
                                  return (
                                    <Menu.Item key={route.key + ""}>
                                      <Link to={`/home/${route.key}`}>
                                        {t(route.name)}
                                      </Link>
                                    </Menu.Item>
                                  );
                                }
                              })}
                            </SubMenu>
                          );
                        } else return <div></div>;
                      })}
                    </Menu>
                  )}
                </Sider>
              ) : (
                <Drawer
                  placement={
                    this.props.context.curr_dir === "ltr" ? "left" : "right"
                  }
                  closable={false}
                  onClose={this.toggle}
                  visible={!this.state.collapsed}
                >
                  {routes && (
                    <Menu theme="light" mode="inline">
                      {routes.map((item, index) => {
                        let permissions = item.subRoutes.reduce(
                          (arr, next) => arr.concat(next.privileges),
                          []
                        );

                        if (
                          item.name == "Dashboard" &&
                          user_type != "SUPER" &&
                          user_type != "CARE" &&
                          user_type != "LI" &&
                          (item.access || hasAnyPrivilege(permissions))
                        ) {
                          return (
                            <Menu.Item
                              key={item.subRoutes[0].key}
                              icon={item.icon}
                              onClick={() => {
                                this.toggle();
                              }}
                            >
                              <Link to={`/home/${item.subRoutes[0].key}`}>
                                <span>
                                  <Icon type={item.icon} />
                                  <span>{t(item.subRoutes[0].name)}</span>
                                </span>
                              </Link>
                            </Menu.Item>
                          );
                        } else if (
                          item.name != "Dashboard" &&
                          (item.access || hasAnyPrivilege(permissions))
                        ) {
                          return (
                            <SubMenu
                              key={index}
                              title={
                                <span>
                                  <Icon type={item.icon} />
                                  <span>{t(item.name)}</span>
                                </span>
                              }
                            >
                              {item.subRoutes.map((route) => {
                                if (
                                  route.access ||
                                  hasAnyPrivilege(route.privileges)
                                ) {
                                  return (
                                    <Menu.Item
                                      key={route.key + ""}
                                      onClick={() => {
                                        this.toggle();
                                      }}
                                    >
                                      <Link to={`/home/${route.key}`}>
                                        <span>{t(route.name)}</span>
                                      </Link>
                                    </Menu.Item>
                                  );
                                }
                              })}
                            </SubMenu>
                          );
                        } else return <div></div>;
                      })}
                    </Menu>
                  )}
                </Drawer>
              )}
              {this.props.children}
            </Layout>
            {/* Help Modal */}
            <Modal
              title={t("Help & Support")}
              visible={this.state.visibleModel}
              onCancel={() => this.setState({ visibleModel: false })}
              footer={[
                <Button key="close" onClick={() => this.setState({ visibleModel: false })}>
                  {t("Close")}
                </Button>
              ]}
            >
              <p>{t("For assistance with the Vodafone Business IVR system, please contact support.")}</p>
              <p>{t("Support Email")}: support@vodafone.com</p>
              <p>{t("Support Phone")}: +1-800-123-4567</p>
            </Modal>
            <HintModal />
          </Layout>
        )}
      </Translation>
    );
  }
}

export default withSharedStateConsumer(withRouter(AdaptiveDrawer));
